const MAX_PARAMETER_LENGTH = 100;

const cleanString = (value) => String(value ?? "")
  .trim()
  .slice(0, MAX_PARAMETER_LENGTH);

const cleanNumber = (value) => {
  if (value === "" || value === null || value === undefined) {
    return undefined;
  }

  const number = Number(value);
  return Number.isFinite(number) ? number : undefined;
};

const getPromoType = (athlete) => {
  if (athlete?.easy) return "easy";
  if (athlete?.hard) return "hard";
  if (athlete?.promo) return cleanString(athlete.promo) || "promo";
  return "standard";
};

const compactParams = (params) => Object.entries(params).reduce((result, [key, value]) => {
  if (value !== "" && value !== undefined && value !== null) {
    result[key] = value;
  }
  return result;
}, {});

const buildAthleteAnalyticsParams = (athlete, extraParams = {}) => compactParams({
  athlete_id: cleanString(athlete?.athlete_id || athlete?.uid || athlete?.term_id),
  athlete_name: cleanString(athlete?.name || athlete?.athlete_name),
  sport: cleanString(athlete?.league || athlete?.sport).toLowerCase(),
  team: cleanString(athlete?.team_short || athlete?.team),
  stat_type: cleanString(athlete?.stat_key).replace(/^projected_/, ""),
  selection_type: cleanString(athlete?.selected).toLowerCase(),
  line_value: cleanNumber(athlete?.stat),
  promo_type: getPromoType(athlete),
  ...extraParams,
});

const pushAnalyticsEvent = (eventName, params = {}) => {
  if (typeof window === "undefined" || !eventName) {
    return false;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...compactParams(params) });
  return true;
};

const trackAthleteSelected = (athlete, { lineupSize, selectionAction = "added", selectionSource = "board" } = {}) => (
  pushAnalyticsEvent("select_athlete", buildAthleteAnalyticsParams(athlete, {
    lineup_size: cleanNumber(lineupSize),
    selection_action: cleanString(selectionAction),
    selection_source: cleanString(selectionSource),
  }))
);

const trackEntrySubmitted = (athletes, {
  entryId,
  isHeadToHead = false,
  multiplierType,
  payout,
  wager,
} = {}) => {
  const selections = Array.isArray(athletes) ? athletes : [];
  const sharedParams = compactParams({
    entry_id: cleanString(entryId),
    athlete_count: selections.length,
    wager_value: cleanNumber(wager),
    projected_payout: cleanNumber(payout),
    multiplier_type: cleanString(multiplierType),
    is_head_to_head: isHeadToHead ? "true" : "false",
  });

  pushAnalyticsEvent("entry_submitted", sharedParams);
  selections.forEach((athlete, index) => {
    pushAnalyticsEvent("athlete_entry_submitted", buildAthleteAnalyticsParams(athlete, {
      ...sharedParams,
      athlete_position: index + 1,
    }));
  });
};

export {
  buildAthleteAnalyticsParams,
  pushAnalyticsEvent,
  trackAthleteSelected,
  trackEntrySubmitted,
};
